import React, { useEffect, useState } from "react";
import {
  Input,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { apiGet } from "../helpers/api";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
    marginLeft: "5px",
    marginTop: "16px",
    marginBottom: "8px",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

function StoreFilter(props) {
  const classes = useStyles();
  const theme = useTheme();

  const [stores, setStores] = useState([]);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const fetchStores = async () => {
    // get data from api
    try {
      const response = await apiGet("/references/stores");
      setStores(response.data);
    } catch (e) {
      console.log(e.response?.data?.message);
    }
  };

  useEffect(() => {
    fetchStores();
  }, []);

  return (
    <>
      <FormControl className={classes.formControl}>
        <InputLabel shrink>Stores</InputLabel>
        <Select
          labelId="demo-mutiple-name-label"
          id="demo-mutiple-name"
          multiple
          value={props.value}
          onChange={props.onChange}
          input={<Input />}
          MenuProps={MenuProps}
        >
          {stores.map((store) => {
            const name = store.email.split("@")[0];
            return (
              <MenuItem
                key={store.id}
                value={store.id}
                style={getStyles(store.email, props.value, theme)}
              >
                {name}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </>
  );
}

export default StoreFilter;
